'use strict';
/**
 * "Rookie" - imported community GLB (low-poly_tank.glb). Cleanly separated
 * body/head/cannon/wheels/exhausts made this the easiest import to rig -
 * full turret articulation through the shared pipeline (gltf-tank-kit.js).
 */
import { buildGLTFTank, ROOKIE_ACCESSORY_LAYOUT } from './gltf-tank-kit.js';

export const NAME = 'Rookie';
export const TAGLINE = 'Imported community model - a tidy low-poly trainee, clean enough to rig a proper turret onto.';

const MODEL_URL = new URL('../models/low-poly.glb', import.meta.url);

export function buildTank(overrides) {
  return buildGLTFTank({
    url: MODEL_URL,
    // default fracs put the eyes near the top of the hull and spaced
    // narrower than this model's actual headlight fixtures; nudge both to
    // land the googly eyes right on top of them.
    eyeHeightFrac: 0.56,
    eyeSepFrac: 0.17,
    // this hull is short relative to its barrel length - the default scan
    // sweep swings the barrel tip out past the hull's silhouette.
    turretScanAmplitude: 0.14,
    // the googly eyes sit right where the model's own headlights are -
    // housing + lens mesh, both redundant now.
    hideParts: ['headlights_0', 'headlights_1'],
    // hand-calibrated exhaust-smoke placement (see gltf-tank-kit.js) -
    // vertex-scanning the pipe meshes kept misreading the bend.
    accessoryLayout: ROOKIE_ACCESSORY_LAYOUT,
    ...overrides,
  });
}
